@if (bold) {
  <b>{{ prettyId }}</b>
} @else {
  {{ prettyId }}
}

@if (allowCopy) {
  <button (click)="copyId($event)"
    class="copy-id-btn"
    matTooltip="Cliquer pour copier l'ID" mat-icon-button color="accent">
    <mat-icon>content_paste</mat-icon>
  </button>
}
